import { render, staticRenderFns } from "./page05.vue?vue&type=template&id=a016815e&scoped=true&"
import script from "./page05.vue?vue&type=script&lang=js&"
export * from "./page05.vue?vue&type=script&lang=js&"
import style0 from "./page05.vue?vue&type=style&index=0&id=a016815e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a016815e",
  null
  
)

export default component.exports